import { Outlet, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import useHasAccess from '../hooks/use-has-access.hook';

interface HasAccessRouteProps {
  onlyRoot?: boolean;
  view?: string[];
}

function HasAccessRoute({ onlyRoot, view }: HasAccessRouteProps) {
  const navigate = useNavigate();
  const { isAllowed } = useHasAccess({ onlyRoot, view });

  useEffect(() => {
    if (isAllowed === false) {
      navigate('/404');
    }
  }, [isAllowed, navigate]);

  if (isAllowed === null) return null;

  return <Outlet />;
}

export default HasAccessRoute;
